/** @format */

import { commonProps } from "../commonTypes";
import { commonParentCompProps } from "../commonParentCompPropsTypes";

//all the interface and types for useReducer
export type InitialStateProps = {
  apiLoading: boolean;
  modalInfo: {
    noteModalOpen: boolean;
    attachmentModalOpen: boolean;
  };
  modalNoteAndAttQuestionId: string;
  uploadedFiles: Map<
    string,
    {
      selectedFiles: string[];
    }
  >;
  allQuestionIds: string[];
  questionIdsToRender: string[];
  noteState: {
    [key: string]: string;
  };
  fileUploadModal: boolean;
  fileUploadQuestionId: string;
  maxFileSizeExceededNames: Map<string, Set<string>>;
  numberQuesHash: Set<string>;
  validNumberErrorMessage: {
    [key: string]: string;
  };
};
export enum ActionKind {
  // IS_EDIT = "is_edit",
  // IS_NOTE_MODAL_OPEN = "is_note_modal_open",
  API_LOADING = "api_loading",
  HANDLE_NOTE_AND_ATTACH_MODAL = "handles_modal_change",
  OPEN_FILE_UPLOAD_MODAL = "open_file_upload_modal",
  MODAL_NOTE_AND_ATT_QUESTION_ID = "modal_note_and_att_question_id",
  CLEAR_UPLOADED_FILES = "clear_uploaded_files",
  HANDLE_FILE_CHANGE = "handle_file_change",
  CREATE_NEW_UPLOADED_FILE_MAP = "create_new_uploaded_file_map",
  ALL_QUESTION_IDS = "all_question_ids",
  QUESTION_IDS_TO_RENDER = "question_ids_to_render",
  REMOVE_SELECTED_FILES = "remove_selected_files",
  NOTE_ONCHANGE = "note_on_change",
  SET_NOTE_STATE_FROM_SURVEY_ANSWER = "set_note_state_from_survey_answers",
  CLEAR_NOTE = "clear_note",
  HANDLE_FILE_CHANGE_FOR_FILE_UPLOAD = "handle_file_change_for_file_upload",
  REMOVE_ADDED_FILES_FOR_FILE_UPLOAD = "remove_added_files_for_file_upload",
  SET_NUMBER_QUES_ID_HASH = "set_number_ques_id_hash",
  SET_VALID_NUMBER_ERROR_MSG = "set_valid_number_error_msg",
  REMOVE_QUES_ID_FROM_NUM_HASH = "remove_ques_id_from_num_hash",
}

export type ReducerAction =
  | {
      type: ActionKind.API_LOADING;
      payload: boolean;
    }
  | {
      type: ActionKind.HANDLE_NOTE_AND_ATTACH_MODAL;
      payload: {
        modalType: string;
        questionId?: string;
      };
    }
  | {
      type: ActionKind.OPEN_FILE_UPLOAD_MODAL;
      payload: {
        toggleState: boolean;
        questionId?: string;
      };
    }
  | {
      type: ActionKind.CLEAR_UPLOADED_FILES;
      payload: {
        questionId: string;
      };
    }
  | {
      type: ActionKind.HANDLE_FILE_CHANGE;
      payload: {
        files: any;
      };
    }
  | {
      type: ActionKind.HANDLE_FILE_CHANGE_FOR_FILE_UPLOAD;
      payload: {
        files: any;
        fileLimit: number;
        maxFileSize: number;
        questionId: string;
      };
    }
  | {
      type: ActionKind.CREATE_NEW_UPLOADED_FILE_MAP;
    }
  | {
      type: ActionKind.ALL_QUESTION_IDS;
      payload: {
        allQuestionIdsDummy: string[];
      };
    }
  | {
      type: ActionKind.QUESTION_IDS_TO_RENDER;
      payload: { updatedFilterData: string[] };
    }
  | {
      type: ActionKind.REMOVE_SELECTED_FILES;
      payload: string;
    }
  | {
      type: ActionKind.REMOVE_ADDED_FILES_FOR_FILE_UPLOAD;
      payload: string;
    }
  | {
      type: ActionKind.NOTE_ONCHANGE;
      payload: string;
    }
  | {
      type: ActionKind.SET_NOTE_STATE_FROM_SURVEY_ANSWER;
      payload: SupplierViewPropsTypes["surveyAnswers"];
    }
  | {
      type: ActionKind.CLEAR_NOTE;
      payload: string;
    }
  | {
      type: ActionKind.SET_NUMBER_QUES_ID_HASH;
      payload: string;
    }
  | {
      type: ActionKind.SET_VALID_NUMBER_ERROR_MSG;
      payload: {
        questionId: string;
        errorMessage: string;
      };
    }
  | {
      type: ActionKind.REMOVE_QUES_ID_FROM_NUM_HASH;
      payload: string;
    };

export type SupplierViewPropsTypes = {
  removeAttachedFile: (key: string) => void;
  handleNoteComment: (questionId: string) => void;
  isPreview: boolean;
  surveyAnswersInfo: commonParentCompProps["surveyAnswersInfo"];
  surveyAnswers: commonParentCompProps["surveyAnswers"];
  handleChangeAddComment: (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  handleChangeClearComment: (question: string) => void;
  SaveAsDraft: () => void;
  handleSubmitAnswers: () => void;
  questionObjVariable: commonProps["Question"]["questionObj"];
  isSurveyLoaded?: boolean;
  handleDeleteFile?: (key: string, id: string) => void;
  monthsHash?: {
    [key: string]: string;
  };
  confirmSubmit: () => void;

  confirmDeleteFile: (key: string, id?: string) => void;
  params: string | null;
  handleClearAnswer: (
    questionId: string,
    questionType: string,
    eventType?: string
  ) => void;
  mainRefObject: commonProps["mainRefObject"];
  dependencyAnsHash: Set<string>;
  setDependencyAnsHash: React.Dispatch<React.SetStateAction<Set<string>>>;
  setSurveyAnswers?: React.Dispatch<
    React.SetStateAction<commonParentCompProps["surveyAnswers"]>
  >;
  clearValuesFromSurveyAnswers(
    questionId: string,
    surveyAnswersCopy?: SupplierViewPropsTypes["surveyAnswers"],
    eventType?: string
  ): void;
  checkNestedDependency?(
    dependentChildrenArray: Array<string>,
    surveyAnswersCopy: commonParentCompProps["surveyAnswers"],
    dependencyAnsHashCopy: Set<string>
  ): void;
  clearAllFiles?(questionId: string): void;
  oldOption: React.MutableRefObject<string>;
  reducerState: InitialStateProps;
  dispatch: React.Dispatch<ReducerAction>;
  questionIdRefs: any;
  downloadAttachmentFile: (fileKey: string, fileName: string) => Promise<void>;
  getBaseSurveyAnswer: commonParentCompProps["getBaseSurveyAnswer"] | null;
  handlePastResponseViewChange: () => void;
  isPastResponseView: boolean;
  taggedSurveyNotAnsweredNote: string;
  handleNotApplicableToggle: (questionId: string, questionType: string) => void;
  handleNotApplicableNote: (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    questionId: string
  ) => void;
  setIsHoveredLabel: React.Dispatch<React.SetStateAction<{}>>;
  isHoveredLabel: { [key: string]: boolean };
  questionIndexMap: { [key: string]: number };
};
export interface ModifiedDataParamsForPut {
  surveyAnswers: SupplierViewPropsTypes["surveyAnswers"];
  status: SupplierViewPropsTypes["surveyAnswersInfo"]["surveyStatus"];
  questionIds?: Array<string>;
  fileUploadQuesIdsWithFiles?: Array<string>;
}
